import React, { useState } from "react";

import { DateTimePicker as MDateTimePicker } from "@material-ui/pickers";
import type { DateTimePickerProps } from "formik-material-ui-pickers";
import { fieldToDateTimePicker } from "formik-material-ui-pickers";
import type { Moment } from "moment-timezone";
import moment from "moment-timezone";

type OwnProps = {
    clearable?: boolean;
    timeZone: string;
};

export const DateTimePicker = (props: DateTimePickerProps & OwnProps) => {
    const { clearable, timeZone, ...otherProps } = props;

    const {
        form: { setFieldValue, setFieldError, errors },
        field: { name },
    } = otherProps;

    const [lastError, setLastError] = useState<{
        value: Moment;
        error: string;
    }>();

    // Custom error handling since picker removes manually set api errors
    const handleError = (newError: string, newValue: Moment) => {
        const currentFieldError = errors[name];
        if (!lastError || !lastError.value.isSame(newValue) || (newError && newError !== currentFieldError)) {
            if (moment.isMoment(newValue)) {
                setLastError({ value: newValue, error: newError });
            }
            if (newError !== currentFieldError && !(!newError && !currentFieldError)) {
                setFieldError(name, newError ? String(newError) : undefined);
            }
        }
    };

    const onChange = React.useCallback(
        (dateTime: Moment) => {
            setFieldValue(name, dateTime);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [name],
    );

    return (
        <MDateTimePicker
            {...fieldToDateTimePicker(otherProps)}
            ampm={false}
            clearable={clearable}
            onChange={(dateTime) => onChange(dateTime as unknown as Moment)}
            onError={(error, val) => handleError(error as unknown as string, val as unknown as Moment)}
        />
    );
};
